import "@/App.css";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import ServicePage from "@/pages/ServicePage";
import AdminLeads from "@/pages/AdminLeads";
import ScrollManager from "@/components/site/ScrollManager";
import { SERVICE_PAGES } from "@/content/servicePages";

function App() {
  return (
    <div className="App">
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        {Object.keys(SERVICE_PAGES).map((path) => (
          <Route key={path} path={path} element={<ServicePage path={path} />} />
        ))}
      </Routes>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
